import { Container, Row, Col, ListGroup } from 'react-bootstrap';
import { useLocation, Navigate, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import InfoBanner from '../../../components/InfoBanner/InfoBanner.jsx';
import useAccessType from '../../../hooks/useAccessType.js';

function ArticleIdeasGeneratedScreen() {
    const { t } = useTranslation();
    const location = useLocation();
    const ideas = location.state?.ideas;
    const keyword = location.state?.keyword;
    const language = location.state?.language;
    const navigate = useNavigate();
    const { isDemo } = useAccessType();

    if (!ideas || !keyword || !language) {
        return (
            <Navigate to="/" />
        );
    }

    return (
        <Container className="py-5">
            {isDemo && (
                <InfoBanner />
            )}

            {/* Header with Original Keyword */}
            <Row className="mb-4">
                <Col xs={12}>
                    <div className="card-custom-content">
                        <h3 className="card-title mb-3">{t('app.keyword')}</h3>
                        <p className="card-text">{keyword}</p>
                    </div>
                </Col>
            </Row>

            {/* Article Ideas List */}
            <Row>
                <Col xs={12}>
                    <ListGroup>
                        {ideas.map((idea, index) => (
                            <ListGroup.Item
                                key={index}
                                onClick={() => navigate('/article/generator', { state: { subject: idea, language } })}
                                role="button"
                                className="d-flex align-items-center gap-3 py-3"
                            >
                                <span className="badge bg-dark rounded-circle">{index + 1}</span>
                                <p className="card-text">{idea}</p>
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                </Col>
            </Row>
        </Container>
    );
}

export default ArticleIdeasGeneratedScreen;
